import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  CartesianGrid,
  Cell,
} from 'recharts';
import { useBreakpoint } from '~/hooks';
import { ValuationItemType } from '~/types/valuationTypes';
import formatTooltipValue from '~valuation/utils/formatTooltipValue';

const CompareMarketValue = ({
  valuationData,
}: {
  valuationData: ValuationItemType;
}) => {
  const { t, i18n } = useTranslation('app');
  const locale = i18n.language;
  const purchasePrice = valuationData.purchasePrice;
  const valuationPrice = valuationData.currentValuation.valuationPrice;
  const { mobileScreen } = useBreakpoint();

  const data = React.useMemo(
    () => [
      {
        name: t('purchasePriceText'),
        value: purchasePrice,
        fill: '#E8F2F9',
      },
      {
        name: t('valuationPriceText'),
        value: valuationPrice,
        fill: '#75B4DB',
      },
    ],
    [t, purchasePrice, valuationPrice],
  );

  return (
    <div className="flex flex-col gap-3x">
      <p className="text-title_4 text-gray__dark_2">
        {t('compareMarketValueTitle')}
      </p>
      <div className="h-[200px]">
        <ResponsiveContainer
          width="100%"
          height="100%"
          //style={{ pointerEvents: 'none' }}
        >
          <BarChart data={data} barCategoryGap="30%" className="md:pe-2x">
            <CartesianGrid strokeDasharray="5 5" vertical={false} />

            <YAxis
              tickFormatter={(v) => `${(v / 1_000_000).toFixed(1)}M`}
              width={50}
              tickMargin={locale === 'ar' ? 45 : 10}
            />

            <XAxis dataKey="name" />

            <Tooltip
              formatter={(v) => [formatTooltipValue(v, t), null]}
              labelStyle={{ direction: locale === 'ar' ? 'rtl' : 'ltr' }}
              cursor={false}
              labelFormatter={() => ''}
            />

            <Bar
              dataKey="value"
              radius={[10, 10, 0, 0]}
              activeBar={false}
              isAnimationActive={false}
            >
              {data.map((entry, i) => (
                <Cell
                  key={i}
                  fill={entry.fill}
                  width={mobileScreen ? 72 : 273}
                />
              ))}
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default CompareMarketValue;
